import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import Table from "./shared/table";
import Pagination from "./pagination";
import { AiOutlineEye } from "react-icons/ai";
import { Badge } from "flowbite-react";
import { Icon } from "@iconify/react";
import Avatar from "./shared/chat/avatar";
import { CityCodes } from "./shared/CityCode";
import { backendURL } from "../config/api";
import { GetUrgentRequestList } from "../utils/services/patient";
import { PatientListfilter, getPatientDetails } from "../redux/actions/passActions";
import { toastError } from "../utils/helpers/methods";
import PatientFilters from "./shared/PatientFilter";
const UrgentRequestList = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { Patientfilter, loading: filterLoading } = useSelector((state) => state.pass);
  const { doctorDetails, userInfo, userToken } = useSelector((state) => state.auth);

  const [patientData, setPatientData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [totalCount, setTotalCount] = useState(0);

  const [filterVal, setFilterVal] = useState({
    search: "",
    status: "active",    
    dob: "",
    patient_login: "1",  
    group: "",
    tag: "",
    locations: [],
    team: [],
  });
  const [selectedLocations, setSelectedLocations] = useState([]);
  const [selectedTeams, setSelectedTeams] = useState([]);

  const [selectedGroupName, setSelectedGroupName] = useState("");

  let patientUrl = `${backendURL}/img/patient`;

  const fetchUrgentList = async ({
    page           = 1,
    search_key     = "",
    status         = "active",
    dob            = "",
    patient_login  = "1",
    employer_filter = "",
    patient_tag    = "",
    locations      = [],
    team           = [],
  } = {}) => {
    try {
      setIsLoading(true);
      const userInfo = JSON.parse(localStorage.getItem("userInfo")) || {};
      const payload = {
        practitioner_id:  doctorDetails?.id?.toString() || "10",
        employer_filter:  employer_filter,
        patient_tag:      patient_tag,
        search_key:       search_key,
        page:             page,
        user_type:        userInfo?.doctor_login?.user_type,
        dob:              dob,
        status:           status,
        patient_login:    patient_login,
        location_filter:  locations,
        team_filter:      team,
      };
      const response = await GetUrgentRequestList(payload);
      if (response?.data?.result === "success") {
        setPatientData(response.data.data || []);
        setTotalPages(response.data.total_pages || 0);
        setTotalCount(response.data.total_count || 0);
        setCurrentPage(page);
      }
    } catch (error) {
      console.error("Error fetching urgent request list", error);
    } finally {
      setIsLoading(false);
    }
  };

    const formatDOBToUS = (dob) => {
    if (!dob) return ''
    if (dob.includes('-')) {
      const [year, month, day] = dob.split('-')
      return `${month}/${day}/${year}`
    }
    return dob
  }

  useEffect(() => {
    if (userInfo?.id) {
      dispatch(PatientListfilter({ practitioner_id: userInfo.id, token: userToken }));
    }
    fetchUrgentList();
    // eslint-disable-next-line
  }, [doctorDetails?.id]);

  const handleFilter = () => {
    fetchUrgentList({
      page:            1,
      search_key:      filterVal.search,
      status:          filterVal.status,
      dob:             filterVal.dob,
      patient_login:   filterVal.patient_login,
      employer_filter: selectedGroupName,
      patient_tag:     filterVal.tag,
      locations:       filterVal.locations,
      team:            filterVal.team,
    });
  };

  const handleResetFilters = () => {
    setFilterVal({
      search: "",
      status: "active",
      dob: "",
      patient_login: "1",
      group: "",
      tag: "",
      locations: [],
      team: [],
    });
    setSelectedLocations([]);
    setSelectedTeams([]);
    setSelectedGroupName("");
    fetchUrgentList({ page: 1, status: "active", patient_login: "1" });
  };

  const handlePageChange = (pageNumber) => {
    fetchUrgentList({
      page:            pageNumber,
      search_key:      filterVal.search,
      status:          filterVal.status,
      dob:             filterVal.dob,
      patient_login:   filterVal.patient_login,
      employer_filter: selectedGroupName,
      patient_tag:     filterVal.tag,
      locations:       filterVal.locations,
      team:            filterVal.team,
    });
  };

  const gotoChat = async (findChat) => {
    try {
      const response = await dispatch(
        getPatientDetails({ token: userToken, patientId: findChat.id })
      ).unwrap();
      if (response?.data?.data !== null) {
        navigate("/chat", { state: response?.data?.data });
      } else {
        toastError("Not able to chat at this moment.");
      }
    } catch {
      toastError("Something went wrong.");
    }
  };

  const columns = [
    {
      header: "",
      cell: (row) => (
        <Link to={`/patientDetails/${row.id}`}>
          <Avatar
            fname={!row.address.profile_image && row.address.first_name}
            lname={!row.address.profile_image && row.address.last_name}
            image={
              row.address.profile_image
                ? `${patientUrl}/${row.address.profile_image}`
                : ""
            }
            className={"hover:cursor-pointer"}
            showStatus={false}
          />
        </Link>
      ),
    },
    {
      header: "Name",
      cell: (row) => (
        <Link
          to={`/patientDetails/${row.id}`}
          className="text-everglade-800 font-bold py-2 px-3 mx-2 rounded"
        >
          <div className="flex flex-row items-center">
            {row?.address?.first_name + " " + row?.address?.last_name}
            {row?.is_vip === 1 && (
              <Icon
                className="ml-2 mb-2"
                icon="quill:vip"
                fontSize={30}
                color="#ffbf00"
              />
            )}
          </div>
        </Link>
      ),
    },
    {
      header: "DOB",
      cell: (row) => <>{formatDOBToUS(row?.address?.dob)}</>,
    },
    {
      header: "Status",
      cell: (row) => (
        <div className="flex flex-row">
          <Badge color={!row?.deleted_at ? "success" : "failure"}>
            {!row?.deleted_at ? "Active" : "InActive"}
          </Badge>
        </div>
      ),
    },
    {
      header: "Location",
      cell: (row) => (
        <div className="flex flex-row">
          {row?.patientlocation?.length > 0 ? (
            <div className="bg-red-800 text-white rounded">
              <span className="text-white m-1 uppercase font-bold">
                {CityCodes[row?.patientlocation[0]?.location_name] ||
                  row?.patientlocation[0]?.location_name}
              </span>
            </div>
          ) : (
            "-"
          )}
        </div>
      ),
    },
    {
      header: "Current Employer",
      cell: (row) => (
        <div className="flex flex-row">
          {row?.location_group?.group_name && (
            <Badge color="info">{row?.location_group?.group_name}</Badge>
          )}
        </div>
      ),
    },
    {
      header: "Relationship",
      cell: (row) => <>{row?.address?.relationship}</>,
    },
    {
      header: "Chat",
      cell: (row) => (
        <>
          {row?.patient_login !== null &&
            row?.patient_login?.sendbird_user_id != null &&
            row?.patient_login?.sendbird_user_id !== "" &&
            row?.practice != null &&
            row?.practice?.def_provider_id != null && (
              <Icon
                icon={"humbleicons:chat"}
                fontSize={30}
                className="text-everglade-500 cursor-pointer"
                // onClick={() => gotoChat(row)}
              />
            )}
        </>
      ),
    },
    {
      header: "Severity",
      cell: (row) => (
        <div className="flex flex-row">
          {row?.patient_login?.urgent_button === 1 ? (
            <Badge color="failure">Urgent</Badge>
          ) : (
            <Badge color="info">Normal</Badge>
          )}
        </div>
      ),
    },
    {
      header: "View",
      cell: (row) => (
        <div className="text-sm text-everglade-800">
          <Link
            to={`/patientDetails/${row.id}`}
            className="text-everglade-800 font-bold py-2 px-3 mx-2 rounded"
          >
            <AiOutlineEye size={24} className="cursor-pointer" />
          </Link>
        </div>
      ),
    },
  ];

  return (
    <div className="w-full">
      <div className="w-full h-full overflow-x-hidden">
        <div className="mx-auto">
          <section>
            <Table
              loader={isLoading}
              columns={columns}
              data={patientData}
              count={0}
              defaultPage={1}
              page={currentPage}
              onChange={handlePageChange}
              totalPages={totalPages}
              header={() => (
                <section className="w-full grid grid-cols-1 lg:grid-cols-1 gap-3 justify-between items-center">
                  <h1 className="text-base w-[150px] font-semibold text-everglade-900 pl-2 shrink-0 uppercase">
                    URGENT LIST
                  </h1>
                
                  {Patientfilter && !filterLoading && (
                    <PatientFilters
                      filterVal={filterVal}
                      setFilterVal={setFilterVal}
                      Patientfilter={Patientfilter}
                      selectedLocations={selectedLocations}
                      selectedTeams={selectedTeams}
                      onLocationsChange={setSelectedLocations}
                      onTeamsChange={setSelectedTeams}
                      onFilter={handleFilter}
                      onReset={handleResetFilters}
                      onGroupNameChange={setSelectedGroupName}
                    />
                  )}
                </section>
              )}
            />

            {patientData.length > 0 && (
              <div className="pagination my-3 flex justify-center pr-4 w-full md:justify-end">
                {totalPages > 0 && (
                  <Pagination
                    count={10}
                    defaultPage={1}
                    page={currentPage}
                    onChange={handlePageChange}
                    totalPages={totalPages}
                    totalCount={totalCount}
                  />
                )}
              </div>
            )}
          </section>
        </div>
      </div>
    </div>
  );
};

export default UrgentRequestList;